import * as React from "react";
import "./GridTable.scss";
import { DataGrid } from "@mui/x-data-grid";

function GridTable({
  rows,
  columns,
  pageSize,
  page,
  rowsPerPageOptions,
  onPageChange,
  onClick,
  onRowClick,
  checkboxSelection,
  loading,
  components,
  disableSelectionOnClick,
  onSelectionModelChange,
  rowCount,
  getRowId,
  isRowSelectable,
  hideFooterPagination = false,
  selectionModel,
  RowClassName,
  disableColumnSelector = true,
  disableColumnFilter = true,
  disableColumnMenu = true,
  initialState = "",
  onColumnVisibilityModelChange = "",
  onPageSizeChange,
  // Opt-in only. `.table_style_ui` gives every grid a hard `height: 430px`
  // (App.scss), which is right for a full-page list but leaves a short table
  // sitting in a tall box with a scrollbar it doesn't need. Passing this lets a
  // caller hand MUI its own row-count-derived height instead. Left `undefined`
  // by default so the 100+ existing call sites keep the fixed-height behaviour
  // they were laid out against.
  autoHeight,
  // Opt-in only, same reasoning as autoHeight. MUI computes autoHeight's total
  // container height from these numeric props (default 52/56), not from
  // whatever a caller's CSS shrinks the rows to visually — a caller that only
  // overrides row/cell height via CSS (e.g. reportDashboard.scss's `!important`
  // 32px rows) still gets autoHeight math done against the unset 52px default,
  // leaving dead space under every table. Left `undefined` so existing callers
  // (which size via CSS/height:430px, not autoHeight) are unaffected.
  rowHeight,
  headerHeight,
}) {
  // MUI merges props over DATA_GRID_PROPS_DEFAULT_VALUES with Object.assign
  // semantics, so forwarding an explicit `undefined` CLOBBERS the library
  // defaults (rowHeight 52 / headerHeight 56) instead of falling back to them.
  // Only pass each through when a caller actually opted in.
  const sizingProps = {
    ...(autoHeight !== undefined && { autoHeight }),
    ...(rowHeight !== undefined && { rowHeight }),
    ...(headerHeight !== undefined && { headerHeight }),
  };
  //
  return (
    <DataGrid
      className="overrideDataGrid"
      {...sizingProps}
      getRowId={getRowId}
      selectionModel={selectionModel}
      rows={rows}
      columns={columns}
      page={page}
      pageSize={pageSize}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageSizeChange={(newPageSize) => onPageSizeChange(newPageSize)}
      isRowSelectable={isRowSelectable}
      onPageChange={onPageChange}
      disableColumnSelector={disableColumnSelector}
      disableColumnFilter={disableColumnFilter}
      disableColumnMenu={disableColumnMenu}
      onCellClick={onClick}
      onRowClick={onRowClick}
      checkboxSelection={checkboxSelection}
      paginationMode="server"
      rowCount={rowCount}
      CanUserAddRows="False"
      IsReadOnly="True"
      onSelectionModelChange={onSelectionModelChange}
      disableSelectionOnClick={disableSelectionOnClick}
      components={components}
      loading={loading}
      hideFooterPagination={hideFooterPagination}
      getRowClassName={RowClassName}
      initialState={initialState}
      onColumnVisibilityModelChange={onColumnVisibilityModelChange}
    />
  );
}

GridTable.propTypes = {};

export default GridTable;
